module.exports = __webpack_public_path__ + "img/20t.prt.7b225049.jpg";